<template>
  <b-col
    cols="12"
    lg="6"
    class="mb-4 mb-lg-0"
  >
    <b-card>
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <feather-icon
              icon="LinkIcon"
              size="20"
              class="text-primary mr-2"
            />
            <h4 class="mb-0">
              UTMs
            </h4>
          </div>
          <b-badge
            variant="light-primary"
            pill
          >
            {{ utms.length }} fontes
          </b-badge>
        </div>
      </template>

      <div
        v-if="loadingUtms"
        class="text-center py-5"
      >
        <b-spinner variant="primary" />
        <p class="text-muted mt-2">
          Carregando UTMs...
        </p>
      </div>

      <div
        v-else-if="utms.length === 0"
        class="text-center py-5"
      >
        <feather-icon
          icon="LinkIcon"
          size="48"
          class="text-muted mb-3"
        />
        <p class="text-muted">
          Nenhuma UTM encontrada no período
        </p>
      </div>

      <app-collapse
        v-else
        type="margin"
      >
        <app-collapse-item
          v-for="utm in utms"
          :key="utm.utm_source"
          :title="`${utm.utm_source || 'Sem fonte'} (${utm.count} pedidos)`"
          :visible="false"
        >
          <div v-if="utm.utm_campaigns && utm.utm_campaigns.length > 0">
            <b-table
              :items="utm.utm_campaigns"
              :fields="utmFields"
              small
              responsive
              hover
              class="mb-0"
            >
              <template #cell(name)="data">
                <span class="font-weight-bold">{{ data.item.name }}</span>
              </template>

              <template #cell(total)="data">
                <b-badge
                  variant="light-info"
                  pill
                >
                  {{ data.item.total }} pedidos
                </b-badge>
              </template>

              <template #cell(amount)="data">
                <span class="text-success font-weight-bold">
                  R$ {{ formatarMoeda(data.item.amount) }}
                </span>
              </template>
            </b-table>
          </div>
          <div
            v-else
            class="text-center py-3"
          >
            <small class="text-muted">Nenhuma campanha associada</small>
          </div>
        </app-collapse-item>
      </app-collapse>
    </b-card>
  </b-col>
</template>

<script>
import {
  BCol, BCard, BSpinner, BBadge, BTable,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { formatarMoeda } from '../services/dashboardService'

export default {
  name: 'UTMsCard',
  components: {
    BCol,
    BCard,
    BSpinner,
    BBadge,
    BTable,
    FeatherIcon,
    AppCollapse,
    AppCollapseItem,
  },
  props: {
    utms: {
      type: Array,
      required: true,
      default: () => [],
    },
    loadingUtms: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      utmFields: [
        { key: 'name', label: 'Campanha', sortable: true },
        {
          key: 'total', label: 'Pedidos', sortable: true, class: 'text-center',
        },
        {
          key: 'amount', label: 'Valor Total', sortable: true, class: 'text-right',
        },
      ],
    }
  },
  methods: {
    formatarMoeda(valor) {
      return formatarMoeda(valor)
    },
  },
}
</script>

<style scoped>
/* Estilos específicos se necessário */
</style>
